let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2DaUN")).then(() => parcelRequire('eKkOj'));